import styled from 'styled-components';
export const FieldWrapper = styled.div `
    padding-top: 20px;
    padding-bottom: 20px;
`;
export const AlignTextCenter = styled.div `
    text-align: center;
`;
//# sourceMappingURL=styled.js.map